import { DisplayObject, Container } from "pixi.js";
import { ScreenManager } from "../screen/ScreenManager";

/**
 * Very simple array sort method for ordering children draw order.
 * You don't generally want to use this for anything more than
 * initialization code.
 */
Container.prototype.sortChildren = function() {
  this.children.sort(this.sortFn);
};

/**
 */
Container.prototype.sortFn = (a: DisplayObject, b: DisplayObject) => {
  return (a.layerIndex || 0) - (b.layerIndex || 0);
};

/**
 */
Object.defineProperty(Container.prototype, "app", {
  get: function() {
    if (!this._app) {
      let foundParentApp = false,
        parent = this.parent;
      while (!foundParentApp && parent) {
        foundParentApp = parent instanceof ScreenManager;
        if (foundParentApp) this._app = parent.app;
        else parent = parent.parent;
      }
    }
    return this._app;
  },
  set: function(value) {
    this._app = value;
  },
  enumerable: true,
  configurable: true
});
